module.exports = __webpack_public_path__ + "img/project-15.1d88e039.jpg";